import { useEffect } from 'react';

import { useNewStrategyContext } from '../../NewStrategyContext';

import { StrategyTable } from '../../StrategyTable';
import { useTranslation } from 'react-i18next';

export const DuplicateOrImport = () => {
  const {
    newStrategy: { assets },
    dispatch,
  } = useNewStrategyContext();

  const { t } = useTranslation();

  useEffect(() => {
    dispatch({ isDisabledNext: assets.length === 0 });
  }, [assets.length, dispatch]);

  return (
    <div
      className={`flex flex-col px-5 pt-5 w-full h-full text-black dark:text-white`}
    >
      <div
        className={`
          flex
          border-r
          border-t
          border-grey-30
          dark:border-grey-70
          h-full
          w-full
        `}
      >
        <StrategyTable
          key={'existing-strategies'}
          tableName={t(
            'strategies.newStrategy.duplicateOrImport.existingStrategies'
          )}
          isNewStrategy={false}
        />
        <StrategyTable
          key={'new-strategy'}
          tableName={t('strategies.newStrategy.duplicateOrImport.newStrategy')}
          isNewStrategy={true}
        />
      </div>
    </div>
  );
};
